module.exports = __webpack_public_path__ + "static/media/white_category_icon_c1.870e2188.svg";